/**
 * NEW SHOPIFY HEADER SYSTEM - NAVIGATION CONTROLLER
 * Handles isolated mobile drawer toggles, department tab switches, 
 * category accordions, trap focus, and keyboard ESC handlers.
 */

document.addEventListener('DOMContentLoaded', () => {
  initNewHeader();
  initNewHeaderSearch();
  initNavScheduleGuard();
});

function initNewHeader() {
  const drawer = document.querySelector('[data-new-header-drawer]');
  const overlay = document.querySelector('[data-new-header-overlay]');
  const openBtns = document.querySelectorAll('[data-new-header-toggle]');
  const closeBtns = document.querySelectorAll('[data-new-header-close]');
  const tabBtns = document.querySelectorAll('[data-new-header-tab]');
  const accordionBtns = document.querySelectorAll('[data-new-header-accordion]');

  if (!drawer) return;

  // Open Mobile Drawer
  openBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      initNavScheduleGuard();
      openDrawer();
    });
  });

  // Close Mobile Drawer
  closeBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeDrawer();
    });
  });

  if (overlay) {
    overlay.addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.classList.add('new-header-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('new-header-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
  }


  // Keyboard ESC Key listener
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  // Mobile Department Tab Switching
  tabBtns.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetDept = tab.dataset.newHeaderTab;

      // Update Active Tab Button
      tabBtns.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      // Update Active Panel
      const panels = drawer.querySelectorAll('[data-new-header-panel]');
      panels.forEach(panel => {
        if (panel.dataset.newHeaderPanel === targetDept) {
          panel.classList.add('is-active');
        } else {
          panel.classList.remove('is-active');
        }
      });
    });
  });

  // Mobile Accordions (Expand/Collapse Category Items)
  accordionBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const parentItem = btn.closest('.new-header-mobile-nav-item');
      if (!parentItem) return;

      const isExpanded = parentItem.classList.contains('is-expanded');
      
      // Close sibling accordions at same level for clean UI
      const siblings = parentItem.parentElement.children;
      Array.from(siblings).forEach(sibling => {
        if (sibling !== parentItem) {
          sibling.classList.remove('is-expanded');
          const toggleBtn = sibling.querySelector('[data-new-header-accordion]');
          if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle current
      if (isExpanded) {
        parentItem.classList.remove('is-expanded');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        parentItem.classList.add('is-expanded');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Live Brand Search Logic
  const brandSearchInputs = document.querySelectorAll('[data-brand-search]');
  brandSearchInputs.forEach(input => {
    input.addEventListener('input', (e) => {
      const query = e.target.value.trim().toLowerCase();
      const parentMega = input.closest('.new-header-mega-menu') || document;

      const brandCards = parentMega.querySelectorAll('[data-brand-card]');
      const noResults = parentMega.querySelector('[data-brand-no-results]');
      let matchCount = 0;

      brandCards.forEach(card => {
        const brandName = (card.dataset.brandName || '').toLowerCase();
        if (query === '' || brandName.includes(query)) {
          card.style.display = '';
          matchCount++;
        } else {
          card.style.display = 'none';
        }
      });

      if (noResults) {
        if (matchCount === 0 && query !== '') {
          noResults.classList.remove('d-none');
          noResults.style.display = 'block';
        } else {
          noResults.classList.add('d-none');
          noResults.style.display = 'none';
        }
      }
    });
  });

  // Mobile Brand Strip Left/Right Navigation Arrows
  const brandNavBtns = document.querySelectorAll('[data-brand-nav]');
  brandNavBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const direction = btn.dataset.brandNav;
      const wrapper = btn.closest('.new-header-mobile-brand-strip-wrapper');
      if (!wrapper) return;
      const strip = wrapper.querySelector('[data-brand-strip]');
      if (!strip) return;

      const scrollDistance = Math.max(160, strip.clientWidth * 0.7);
      if (direction === 'prev') {
        strip.scrollBy({ left: -scrollDistance, behavior: 'smooth' });
      } else {
        strip.scrollBy({ left: scrollDistance, behavior: 'smooth' });
      }
    });
  });
}

/**
 * Predictive Live Search Dropdown for Desktop Search Bar
 */
function initNewHeaderSearch() {
  const searchWrap = document.querySelector('.new-header__search-wrap');
  if (!searchWrap) return;
  const input = searchWrap.querySelector('.new-header__search-input');
  const form = searchWrap.querySelector('.new-header__search-form');
  const dropdown = searchWrap.querySelector('[data-search-dropdown]');
  if (!input || !dropdown) return;

  const rawHidden = (searchWrap.dataset.hiddenVendors || 'Raja Sahib').toLowerCase();
  const hiddenVendors = rawHidden.split(',').map(s => s.trim()).filter(Boolean);

  let debounceTimer;
  let currentController = null;

  input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const query = input.value.trim();

    if (query.length < 2) {
      dropdown.style.display = 'none';
      dropdown.innerHTML = '';
      return;
    }

    debounceTimer = setTimeout(() => {
      fetchPredictiveResults(query);
    }, 200);
  });

  input.addEventListener('focus', () => {
    if (input.value.trim().length >= 2 && dropdown.innerHTML.trim() !== '') {
      dropdown.style.display = 'block';
    }
  });

  document.addEventListener('click', (e) => {
    if (!searchWrap.contains(e.target)) {
      dropdown.style.display = 'none';
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      dropdown.style.display = 'none';
    }
  });

  function fetchPredictiveResults(query) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    dropdown.style.display = 'block';
    dropdown.innerHTML = '<div class="new-header__search-status">Searching...</div>';

    const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][fields]=title,body,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=hide`;

    fetch(url, { signal: currentController.signal })
      .then(res => res.json())
      .then(data => {
        const products = data?.resources?.results?.products || [];
        
        // Filter out hidden vendors
        const visibleProducts = products.filter(p => {
          const v = (p.vendor || '').trim().toLowerCase();
          return !hiddenVendors.includes(v);
        });

        if (visibleProducts.length === 0) {
          dropdown.innerHTML = `<div class="new-header__search-status">No products found for "${escapeHtml(query)}"</div>`;
          return;
        }

        const itemsHtml = visibleProducts.slice(0, 6).map(p => {
          const formattedPrice = formatPrice(p.price);
          return `
            <li>
              <a href="${p.url}" class="new-header__search-result-item">
                ${p.image ? `<img src="${p.image}" alt="${escapeHtml(p.title)}" class="new-header__search-result-img" loading="lazy" width="52" height="52">` : '<div class="new-header__search-result-img"></div>'}
                <div class="new-header__search-result-info">
                  ${p.vendor ? `<div class="new-header__search-result-vendor">${escapeHtml(p.vendor)}</div>` : ''}
                  <h4 class="new-header__search-result-title">${escapeHtml(p.title)}</h4>
                  <div class="new-header__search-result-price">${formattedPrice}</div>
                </div>
              </a>
            </li>
          `;
        }).join('');

        const searchAllUrl = `${form.getAttribute('action') || '/search'}?q=${encodeURIComponent(query)}&type=product&options[unavailable_products]=hide&options[prefix]=last&options[fields]=title,body,tag,vendor,product_type,variants.title,variants.sku`;

        dropdown.innerHTML = `
          <ul class="new-header__search-results-list">
            ${itemsHtml}
          </ul>
          <div class="new-header__search-dropdown-footer">
            <a href="${searchAllUrl}" class="new-header__search-view-all">View all results for "${escapeHtml(query)}" &rarr;</a>
          </div>
        `;
      })
      .catch(err => {
        if (err.name === 'AbortError') return;
        dropdown.innerHTML = '<div class="new-header__search-status">Unable to fetch results</div>';
      });
  }

  function escapeHtml(str) {
    if (!str) return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function formatPrice(amount) {
    if (!amount) return '';
    const num = parseFloat(amount);
    if (isNaN(num)) return amount;
    return 'Rs. ' + Math.round(num).toLocaleString();
  }
}

/**
 * Validates real-time client timestamp against data-nav-schedule-start / end
 * to guard against Shopify edge CDN caching delays.
 */
function initNavScheduleGuard() {
  if (window.Shopify && window.Shopify.designMode) return;
  const now = Math.floor(Date.now() / 1000);
  const scheduledElements = document.querySelectorAll('[data-nav-schedule-start], [data-nav-schedule-end]');
  if (!scheduledElements.length) return;

  scheduledElements.forEach(el => {
    const start = parseInt(el.getAttribute('data-nav-schedule-start'), 10);
    const end = parseInt(el.getAttribute('data-nav-schedule-end'), 10);
    let hide = false;

    if (start && !isNaN(start) && now < start) {
      hide = true;
    }
    if (end && !isNaN(end) && now > end) {
      hide = true;
    }

    if (hide) {
      el.style.display = 'none';
      const subgroup = el.closest('.new-header__cat-subgroup, .new-header-mobile-sub-tree, .new-header__cat-col');
      if (subgroup) {
        const remainingVisible = subgroup.querySelectorAll('li:not([style*="display: none"]), a.new-header__cat-link:not([style*="display: none"])');
        if (remainingVisible.length === 0) {
          subgroup.style.display = 'none';
        }
      }
    }
  });
}

